import SlateEditor from './SlateEditor';

export default SlateEditor;
